module.exports = __webpack_public_path__ + "img/angle_right.f94c802b.svg";